(function () {
  var soldOutText   = '';
  var addToCartText = '';

  /* ── helpers ── */
  function getTranslations() {
    var meta = document.querySelector('[data-sold-out][data-add-to-cart]');
    soldOutText   = (meta && meta.dataset.soldOut)   || 'Sold out';
    addToCartText = (meta && meta.dataset.addToCart) || 'Add to cart';
  }

  function formatMoney(cents, symbol, currencyCode) {
    var val  = cents / 100;
    var str  = val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
    if (currencyCode === 'INR') {
      var parts  = str.split('.');
      var x      = parts[0];
      var result = '';
      if (x.length > 3) {
        result = x.slice(-3); x = x.slice(0, -3);
        while (x.length > 2) { result = x.slice(-2) + ',' + result; x = x.slice(0, -2); }
        result = x + ',' + result;
      } else { result = x; }
      str = parts[1] ? result + '.' + parts[1] : result;
    }
    return symbol + str;
  }

  function handleVariantChange(select) {
    /* 1 – find the card-wrapper ancestor */
    var wrapper = select.closest('.card-wrapper');
    if (!wrapper) return;

    /* 2 – find the JSON data blob (previous sibling of wrapper) */
    var dataEl = wrapper.previousElementSibling;
    if (!dataEl || !dataEl.classList.contains('rc-card-variant-data')) return;

    var variantsData;
    try { variantsData = JSON.parse(dataEl.textContent).variants; } catch (e) { return; }

    var variantMap = {};
    variantsData.forEach(function (v) { variantMap[v.id] = v; });

    var v = variantMap[parseInt(select.value, 10)];
    if (!v) return;

    /* 3 – currency info */
    var currencyEl   = document.querySelector('[data-currency-code]');
    var currencyCode = currencyEl ? currencyEl.dataset.currencyCode : 'INR';
    var symbol       = currencyEl ? currencyEl.dataset.currencySymbol : '₹';

    /* 4 – update elements */
    var inputEl   = wrapper.querySelector('[data-variant-id-input]');
    var atcBtn    = wrapper.querySelector('[data-atc-btn]');
    var atcLabel  = wrapper.querySelector('[data-atc-label]');
    var imgEl     = wrapper.querySelector('.card-variant-img-swap');
    var savingsEl = wrapper.querySelector('[data-savings-badge]');
    var priceWrap = wrapper.querySelector('[data-card-price]');

    if (inputEl)  { inputEl.value = v.id; inputEl.disabled = !v.available; }
    if (atcBtn)   { atcBtn.disabled = !v.available; }
    if (atcLabel) { atcLabel.textContent = v.available ? addToCartText : soldOutText; }
    if (imgEl && v.image) { imgEl.src = v.image; imgEl.srcset = ''; }

    if (priceWrap) {
      var priceDiv    = priceWrap.querySelector('.price');
      var salePriceEl = priceWrap.querySelector('.price-item--sale');
      var regularEl   = priceWrap.querySelector('.price__regular .price-item--regular');
      var compareEl   = priceWrap.querySelector('s.price-item--regular');
      var pctEl       = priceWrap.querySelector('[data-discount-badge]');

      if (v.compare_at_price > v.price) {
        if (salePriceEl) salePriceEl.textContent = formatMoney(v.price, symbol, currencyCode);
        if (compareEl)   compareEl.textContent   = formatMoney(v.compare_at_price, symbol, currencyCode);
        if (priceDiv)    { priceDiv.classList.add('price--on-sale'); priceDiv.classList.remove('price--sold-out'); }
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        if (pctEl)     { pctEl.textContent = pct + '% OFF'; pctEl.style.display = ''; }
        if (savingsEl) { savingsEl.textContent = 'You save ' + formatMoney(v.compare_at_price - v.price, symbol, currencyCode); savingsEl.style.display = ''; }
      } else {
        if (regularEl) regularEl.textContent = formatMoney(v.price, symbol, currencyCode);
        if (priceDiv)  { priceDiv.classList.remove('price--on-sale'); if (!v.available) priceDiv.classList.add('price--sold-out'); }
        if (compareEl) compareEl.textContent = '';
        if (pctEl)     pctEl.style.display = 'none';
        if (savingsEl) savingsEl.style.display = 'none';
      }
    }
  }

  /* ── single delegated listener on document ── */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-variant-select]')) {
      if (!soldOutText) getTranslations();
      handleVariantChange(e.target);
    }
  });
})();
